export default "__VITE_ASSET__BmOXVl2R__"